import "./global.css";
import { SimpleKitContextProvider } from "./context/SimpleKitContext";
import { SimpleKitModalProvider } from "./web3kit";

export { useSimpleKit } from "./context/SimpleKitContext";
export {
  useAccount,
  useChainInfo,
  useBalance,
  useTokenBalance,
  useBalanceAsync,
  useTokenBalanceAsync,
  useDisconnectAccount,
  useReadContractAsync,
  useWriteContractAsync,
} from "./hooks";

export function SimpleKitProvider({
  chains,
  host,
  name,
  description,
  icon,
  projectId,
  children,
  signMessage,
}: {
  chains: any;
  host: string;
  name: string;
  description: string;
  icon: string;
  projectId: string;
  signMessage: string;
  children: any;
}) {
  return (
    <SimpleKitContextProvider
      chains={chains}
      host={host}
      name={name}
      description={description}
      icon={icon}
      projectId={projectId}
      signMessage={signMessage}
    >
      <SimpleKitModalProvider>{children}</SimpleKitModalProvider>
    </SimpleKitContextProvider>
  );
}
